import { User } from "../../../context/user";
import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react";
import { LocaleType } from "../../../constants/constants";
import React from "react";
import { UserSessionContextReducer, IUserSessionContextDispatcherPayload } from "./user-session-context-reducer";
import { DefaultLanguageProvider } from "./default-language-provider";

export interface IUserSessionContext {
    locale: LocaleType;
    user: User | undefined;
}

const defaultUserSessionContext: IUserSessionContext = {
    locale: new DefaultLanguageProvider().get(),
    user: undefined,
};

export const UserSessionContext = createContext<IUserSessionContext>(defaultUserSessionContext);
export const UserSessionContextDispatcher = createContext<Dispatch<IUserSessionContextDispatcherPayload> | null>(null);

export const UserSessionContextProvider = ({ children }: { children: ReactNode}) => {
    const [userSessionContext, userSessionContextDispatcher] = useReducer(UserSessionContextReducer, defaultUserSessionContext);

    return <UserSessionContext.Provider value={userSessionContext} key={`application-${userSessionContext.locale}`}>
        <UserSessionContextDispatcher.Provider value={userSessionContextDispatcher}>
            {children}
        </UserSessionContextDispatcher.Provider>
    </UserSessionContext.Provider>;
};

export const useUserSessionContext = () => useContext(UserSessionContext);
export const useUserSessionContextDispatcher = () => {
    if (!UserSessionContextDispatcher) {
        throw new Error("useUserSessionContextDispatcher must be used within the context");
    }

    return useContext(UserSessionContextDispatcher)!;
};
